import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "none" }, [
      _createElementVNode("path", { d: "M4.5 11.5h7m-7-3h7m-7-3h2m3-5h-8v15h13v-10z" }),
      _createElementVNode("path", { d: "M9.5.5v5h5" })
    ], -1)
  ]))]))
}
export default { render: render }